import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';

import { enqueueNotification, hideModal } from 'stores';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_QUOTES } from 'lib/quoteBind/queryKeys';

const patchExternallyReferred = async ({ quoteId, value }) => {
  const result = await quoteBindAxios.patch(
    `quotes/${quoteId}/external-referral?externalReferral=${value}`,
  );
  return result?.data;
};

export const usePatchExternallyReferredQuote = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleSuccess = async (riskId) => {
    await queryClient.invalidateQueries({ queryKey: [QB_RISK_QUOTES, { id: riskId }] });

    dispatch(hideModal());
    dispatch(enqueueNotification('Quote updated successfully', 'success' ));
  };

  return useMutation({
    mutationFn: ({ quote, value }) =>
      patchExternallyReferred({ quoteId: quote.id, value }),
    onSuccess: (_, { quote }) => handleSuccess(quote.riskId),
    onError: () => {
      dispatch(enqueueNotification('notification.generic.request', 'error'));
    },
  });
};
